import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import http from './http'

import { Button,ActionSheet,Row, Col,Stepper,Cell, CellGroup,Field,RadioGroup,Radio,
    SubmitBar,Toast,Search,Area,Dialog,Sku} from 'vant';

Vue.config.productionTip = false


Vue.prototype.$http = http

Vue.use(Button).use(ActionSheet).use(Row).use(Col).use(Cell)
    .use(CellGroup).use(Stepper).use(Field).use(RadioGroup).use(Radio).use(SubmitBar)
    .use(Toast).use(Search).use(Area).use(Dialog).use(Sku)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
